define("settings/templates/users/new", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @close={{perform this.handleClose this.user}} as |modal|>
    <modal.card @portrait={{true}}>
      {{#if (or this.isAdmin this.availableSeats)}}
        <modal.card-header @title={{t "account.users.new.title"}} />
      {{else}}
        <modal.card-header @title={{t "account.users.new.manage_title"}} />
      {{/if}}
  
      <ModalForm @cancel={{modal.close}} @task={{task this.handleSubmit this.user}} as |form|>
        <modal.card-body class="u--p__t__0 dd-privacy-mask-user-input">
          {{#if (or this.isAdmin this.availableSeats)}}
            <p class="u--m__b__lg">{{t "account.users.new.remaining_seats" count=this.availableSeats}}</p>
            <form.input
              @autocomplete="name"
              @autofocus={{true}}
              @label={{t "shared_words.name"}}
              @placeholder={{t "account.users.new.name_placeholder"}}
              @value={{this.user.name}}
            />
            <form.input
              @autocomplete="email"
              @label={{t "shared_words.email"}}
              @placeholder={{t "account.users.new.email_placeholder"}}
              @type="email"
              @value={{this.user.email}}
            />
          {{else}}
            <p>{{t "account.users.new.manage_description"}}</p>
          {{/if}}
  
        </modal.card-body>
  
        <modal.card-footer>
          {{#if (or this.isAdmin this.availableSeats)}}
            <form.footer @submitButtonText={{t "account.users.new.submit"}} />
          {{else}}
            <Shared::Ui::Button
              @onClick={{modal.close}}
              @text={{t "shared_words.cancel"}}
              @variant="outline"
              class="u--float--left"
            />
          {{/if}}
        </modal.card-footer>
  
      </ModalForm>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "fmORizeb",
    "block": "[[[8,[39,0],null,[[\"@close\"],[[28,[37,1],[[30,0,[\"handleClose\"]],[30,0,[\"user\"]]],null]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n\"],[41,[28,[37,3],[[30,0,[\"isAdmin\"]],[30,0,[\"availableSeats\"]]],null],[[[1,\"      \"],[8,[30,1,[\"card-header\"]],null,[[\"@title\"],[[28,[37,4],[\"account.users.new.title\"],null]]],null],[1,\"\\n\"]],[]],[[[1,\"      \"],[8,[30,1,[\"card-header\"]],null,[[\"@title\"],[[28,[37,4],[\"account.users.new.manage_title\"],null]]],null],[1,\"\\n\"]],[]]],[1,\"\\n    \"],[8,[39,5],null,[[\"@cancel\",\"@task\"],[[30,1,[\"close\"]],[28,[37,6],[[30,0,[\"handleSubmit\"]],[30,0,[\"user\"]]],null]]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,1,[\"card-body\"]],[[24,0,\"u--p__t__0 dd-privacy-mask-user-input\"]],null,[[\"default\"],[[[[1,\"\\n\"],[41,[28,[37,3],[[30,0,[\"isAdmin\"]],[30,0,[\"availableSeats\"]]],null],[[[1,\"          \"],[10,2],[14,0,\"u--m__b__lg\"],[12],[1,[28,[35,4],[\"account.users.new.remaining_seats\"],[[\"count\"],[[30,0,[\"availableSeats\"]]]]]],[13],[1,\"\\n          \"],[8,[30,2,[\"input\"]],null,[[\"@autocomplete\",\"@autofocus\",\"@label\",\"@placeholder\",\"@value\"],[\"name\",true,[28,[37,4],[\"shared_words.name\"],null],[28,[37,4],[\"account.users.new.name_placeholder\"],null],[30,0,[\"user\",\"name\"]]]],null],[1,\"\\n          \"],[8,[30,2,[\"input\"]],null,[[\"@autocomplete\",\"@label\",\"@placeholder\",\"@type\",\"@value\"],[\"email\",[28,[37,4],[\"shared_words.email\"],null],[28,[37,4],[\"account.users.new.email_placeholder\"],null],\"email\",[30,0,[\"user\",\"email\"]]]],null],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,2],[12],[1,[28,[35,4],[\"account.users.new.manage_description\"],null]],[13],[1,\"\\n\"]],[]]],[1,\"\\n      \"]],[]]]]],[1,\"\\n\\n      \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n\"],[41,[28,[37,3],[[30,0,[\"isAdmin\"]],[30,0,[\"availableSeats\"]]],null],[[[1,\"          \"],[8,[30,2,[\"footer\"]],null,[[\"@submitButtonText\"],[[28,[37,4],[\"account.users.new.submit\"],null]]],null],[1,\"\\n\"]],[]],[[[1,\"          \"],[8,[39,7],[[24,0,\"u--float--left\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,1,[\"close\"]],[28,[37,4],[\"shared_words.cancel\"],null],\"outline\"]],null],[1,\"\\n\"]],[]]],[1,\"      \"]],[]]]]],[1,\"\\n\\n    \"]],[2]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]]],[\"modal\",\"form\"],false,[\"shared/modal\",\"perform\",\"if\",\"or\",\"t\",\"modal-form\",\"task\",\"shared/ui/button\"]]",
    "moduleName": "settings/templates/users/new.hbs",
    "isStrictMode": false
  });
});